var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcAlertBalance(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 92,
    height: 92,
    viewBox: "0 0 92 92",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3476_24338)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46 0C20.5973 0 0 20.5973 0 46C0 71.4027 20.5973 92 46 92C71.4027 92 92 71.4027 92 46C92 20.5973 71.4027 0 46 0ZM46 84.1964C24.9098 84.1964 7.80357 67.0902 7.80357 46C7.80357 24.9098 24.9098 7.80357 46 7.80357C67.0902 7.80357 84.1964 24.9098 84.1964 46C84.1964 67.0902 67.0902 84.1964 46 84.1964Z",
    fill: "#D81717"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.0703 64.0714C41.0703 65.3786 41.5896 66.6322 42.5139 67.5565C43.4381 68.4807 44.6917 69 45.9989 69C47.306 69 48.5596 68.4807 49.4839 67.5565C50.4082 66.6322 50.9275 65.3786 50.9275 64.0714C50.9275 62.7643 50.4082 61.5107 49.4839 60.5864C48.5596 59.6621 47.306 59.1429 45.9989 59.1429C44.6917 59.1429 43.4381 59.6621 42.5139 60.5864C41.5896 61.5107 41.0703 62.7643 41.0703 64.0714ZM43.5346 52.5714H48.4632C48.915 52.5714 49.2846 52.2018 49.2846 51.75V23.8214C49.2846 23.3696 48.915 23 48.4632 23H43.5346C43.0828 23 42.7132 23.3696 42.7132 23.8214V51.75C42.7132 52.2018 43.0828 52.5714 43.5346 52.5714Z",
    fill: "#D81717"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3476_24338"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 92,
    height: 92,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcAlertBalance);
export default __webpack_public_path__ + "static/media/ic-alert-balance.5b086f72ac0c971b87111cd042efd9e1.svg";
export { ForwardRef as ReactComponent };